import * as React from "react";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {useEffect} from "react";
import { OutlinedContainer } from "./OutlinedContainer";
import { ValidationError, convertToTranslationKeys } from "../../../services/validator";
import { FormHelperText } from "@mui/material";
import { t } from "i18next";
import {styled} from "@mui/material";
import { convertBase64 } from "../../../utils/file_upload";

const Image = styled('img')(() => ({
    display: 'block',
    width: 'auto',
    maxHeight: 100,
}));

interface IFileFieldProps {
    variant?: 'outlined' | 'button';
    label: string;
    onChange(value?: File | null): void;
    onDelete?(): void;
    accept?: string;
    preview?: boolean;
    errors?: ValidationError[];
    helperText?: string;
}

export const FileField = ({variant = 'outlined', label, onChange, onDelete, accept, preview, errors, helperText}: IFileFieldProps) => {
    const formId = React.useId();
    const [file, setFile] = React.useState<File | null>();
    const [previewData, setPreviewData] = React.useState<string>('');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!!event.target.files!![0]) {
            setFile(event.target.files!![0]);

            if (!!preview) {
                convertBase64(event.target.files!![0]).then((res: string) => {
                    setPreviewData(res);
                });
            }
        }
    };

    const handleDelete = () => {
        setFile(null);
        onDelete?.();
    };

    useEffect(() => {
        onChange(file);
    }, [file]);

    return (
        <FormControl fullWidth>
            {!!file &&
                <OutlinedContainer label={label}>
                    {!!preview && previewData !== '' && <Image src={previewData} />}

                    <Button
                        color="primary"
                        size="small"
                        onClick={handleDelete}
                    >
                        <DeleteIcon/> Delete file
                    </Button>
                </OutlinedContainer>
            }

            {variant === 'outlined' && !file && (
                <TextField
                    onChange={handleChange}
                    label={label}
                    variant="outlined"
                    type="file"
                    inputProps={{
                        accept: accept,
                    }}
                    InputLabelProps={{ shrink: true }}
                    error={!!errors && !!errors.length}
                    helperText={helperText}
                />
            )}

            {variant === 'button' && !file && (
                <>
                    <input
                        type="file"
                        accept={accept}
                        onChange={handleChange}
                        id={formId}
                        style={{display: 'none'}}
                    />
                    <label htmlFor={formId}>
                        <Button variant="contained" color="primary" component="span" startIcon={<CloudUploadIcon />}>
                            {label}
                        </Button>
                    </label>

                    <FormHelperText>{helperText}</FormHelperText>
                </>
            )}

            {!!errors && !!errors.length &&
                <FormHelperText error>
                    {convertToTranslationKeys(errors).map(e => t(e)).join(', ')}
                </FormHelperText>
            }
        </FormControl>
    );
};
